import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

interface ConfirmFormProps {
    open: boolean;
    title: string;
    content: string;
    onCancel: () => void;
    onConfirm: () => void;
}

/**
 * ConfirmForm
 * Reusable confirmation dialog component.
 * @component
 * @param {ConfirmFormProps} props - Props containing dialog state and handlers.
 * @returns {JSX.Element} Confirmation dialog.
 */
const ConfirmForm: React.FC<ConfirmFormProps> = ({ open, title, content, onCancel, onConfirm }) => {
    return (
        <Dialog open={open} onClose={onCancel}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>{content}</DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color='primary'>
                    Cancel
                </Button>
                <Button onClick={onConfirm} color='error' variant='contained'>
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmForm;
